module.exports = __webpack_public_path__ + "img/logo.caeb8ca9.png";